import React from 'react';
import { ASSETS_URL } from "../constants";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation("footer");
  
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Contact Us Column */}
          <div className="footer-col footer-col-contact">
            <h3 className="footer-title">Contact Us</h3>
            <div className="footer-content">
              <p className="footer-text">
                <i className="fas fa-mobile-alt me-2"></i>
                <a href="tel:+919662267474" className="footer-phone-link">+91 96622 67474</a>
              </p>
              <p className="footer-text">
                <i className="fas fa-map-marker-alt me-2"></i>
                <a 
                  href="https://maps.google.com/?q=52%2FA%2C+Titanium+Building%2C+Prahladnagar+Garden%2C+Ahmedabad-380015%2C+Gujarat" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-phone-link"
                >
                  52/A, Titanium Building,<br />
                  Prahladnagar Garden,<br />
                  Ahmedabad- 380015, Gujarat
                </a>
              </p>
            </div>
          </div>

          {/* Useful Links Column */}
          <div className="footer-col footer-col-links">
            <h3 className="footer-title">Useful Links</h3>
            <div className="footer-content">
              <ul className="footer-links">
                <li><Link to="/business-expansion" className="footer-link">{t("quick-links.business-loan")}</Link></li>
                <li><Link to="/commercial-vehicle-loan" className="footer-link">{t("quick-links.commercial-vehicle-loan")}</Link></li>
                <li><Link to="/supply-chain-financing/anchor-registration" className="footer-link">{t("quick-links.supply-chain-financing")}</Link></li>
                <li><Link to="/emi-calculator" className="footer-link">{t("quick-links.emi-calculator")}</Link></li>
                 </ul>
            </div>
          </div>

          {/* Legal Column */}
          <div className="footer-col footer-col-legal">
            <h3 className="footer-title">Legal</h3>
            <div className="footer-content">
              <ul className="footer-links">
                <li><Link to="/privacy-policy" className="footer-link">{t("legal.privacy-policy")}</Link></li>
                {/* <li><Link to="/business-listing" className="footer-link">{t("quick-links.your-business")}</Link></li>
                <li><Link to="/business-listing-landing" className="footer-link">{t("quick-links.list-your-business")}</Link></li>
             */}
              </ul>
            </div>
          </div>

          {/* Follow Us Column */}
          <div className="footer-col footer-col-follow">
            <h3 className="footer-title">Follow Us</h3>
            <div className="footer-content">
              <div className="social-icons">
                <div className="social-icons-row">
                  <div className="social-icon">
                    <a href="https://www.facebook.com/profile.php?id=61570532138666" target="_blank" rel="noopener noreferrer">
                      <img src={`${ASSETS_URL}images/footer-facebook.svg`} alt="Facebook" />
                    </a>
                  </div>
                  <div className="social-icon">
                    <a href="https://www.instagram.com/growbizh/" target="_blank" rel="noopener noreferrer">
                      <img src={`${ASSETS_URL}images/footer-insta.svg`} alt="Instagram" />
                    </a>
                  </div>
                  <div className="social-icon">
                    <a href="https://www.linkedin.com/company/growbizh/" target="_blank" rel="noopener noreferrer">
                      <img src={`${ASSETS_URL}images/footer-linkedin.svg`} alt="LinkedIn" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
